export const postSanityConfig = {
    projectId: "xkr8xbq6",
    dataset: "production",
  };


